import isVerifyTokenGuard from "@/guards/verifyTokenGuard";

export default {
    name: "voices-of-change",
    component: () => import(/* webpackChunkName: "voices-of-change" */ '@/layouts/PrincipalLayout.vue'),
    children: [
        {
            path: '',
            name: 'voices-of-change-index',
            component: () => import( /* webpackChunkName: "voices-of-change-index" */ '@/modules/voices-of-change/views/Index.vue'),
        },
        {
            path: 'admin-table',
            name: 'voices-of-change-admin',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        transKey: 'breadcrumbs.voices-of-change-admin',
                        isActive: true
                    }
                ]
            },
            component: () => import( /* webpackChunkName: "voices-of-change-admin-table" */ '@/modules/voices-of-change/views/AdminTable.vue'),
        },
        {
            path: 'admin-form',
            name: 'voices-of-change-manage',
            beforeEnter: [isVerifyTokenGuard],
            meta: {
                breadcrumbs: [
                    {
                        route: {
                            name: 'voices-of-change-admin',
                        },
                        transKey: 'breadcrumbs.voices-of-change-admin',
                        isActive: false,
                    },
                    {
                        transKey: 'breadcrumbs.voices-of-change-form',
                        isActive: true
                    }
                ]
            },
            component: () => import( /* webpackChunkName: "voices-of-change-admin-form" */ '@/modules/voices-of-change/views/AdminForm.vue'),
        }
    ]
} 